import React from "react";
import { BASE_UPLOADS } from "../../../utils/constants";
import { useNavigate } from "react-router-dom";

const DetailCourseCard = ({ course }) => {
	const navigate = useNavigate();

	const handleCardClick = () => {
		// Navigate to the course detail page with the courseId as a parameter
		navigate(`/enroll/${course._id}`);
	};
	return (
		<div className="w-full mx-auto h-full bg-white flex flex-col justify-between overflow-hidden">
			<div className="relative">
				<img
					src={
						course.image
							? `${BASE_UPLOADS}/course-pic/${course.image}`
							: "./images/coding.jpg"
					}
					alt={course.category.title}
					className="w-full h-52 object-cover rounded-xl"
				/>
			</div>
			<div className="py-6">
				<h1 className="text-black font-medium text-base mb-2 capitalize text-center">
					{course.name}
				</h1>
				<p className="text-gray-500 text-xs line-clamp-3">
					{course.description}
				</p>

				<div className="flex flex-col items-start mt-4 space-y-2">
					<div className="flex items-center text-sm space-x-2">
						<p className="text-gray-800 font-medium">Instructor:</p>
						<div className="flex items-center space-x-2">
							<p className="text-gray-500">
								{course.teachers
									.map((teacher) => teacher.fullName)
									.join(", ")}
							</p>
						</div>
					</div>

					<div className="flex items-center text-sm space-x-2">
						<div className="text-gray-800 font-medium px-4 py-2 rounded-full bg-indigo-100">
							<img
								src={
									course.teachers.length > 0
										? `${BASE_UPLOADS}/profile/${course.teachers[0]._id}/${course.teachers[0].profilePic}`
										: "./image/coding.jpg"
								}
								alt=""
								className="w-6 h-6 rounded-full"
							/>
						</div>

						<div className="text-mainColor font-medium px-4">
							{course.price || "$200"}
						</div>
					</div>
				</div>
			</div>

			<div>
				<button
					className="bg-white w-full text-black py-3 text-sm border border-gray-400 rounded-full hover:bg-mainColor hover:border-mainColor hover:border-opacity-80 hover:bg-opacity-80 hover:text-white transition duration-500"
					onClick={handleCardClick}
				>
					Get Started
				</button>
			</div>
		</div>
	);
};

export default DetailCourseCard;
